<template>
  <el-row class="white">
    <el-col :offset="1" :span="23">
      <query-form :form="form" v-model="boatKind" @handleQuery="handleQuery">
        <template #export>
          <el-button @click="exportExcel">导出</el-button>
        </template>
      </query-form>
    </el-col>
  </el-row>
  <base-table
    :columns="columns"
    :data="kindList"
    :pager="pager"
    :pageShow="pageShow"
    @handleAction="handleAction"
    @handleCurrentChange="handleCurrentChange">
  </base-table>
</template>

<script>
import useGuideTable from "@/hooks/useGuideTable";
import { getCurrentInstance, reactive, ref } from 'vue';
import utils from '@/utils/utils';
import moment from 'moment';
import { ElMessage } from 'element-plus';

export default {
  name: "orderAll",
  setup() {
    const { proxy } = getCurrentInstance();
    let queryValue = {}
    // 初始化表单对象
    const boatKind = ref({
      _id: '',
      beginWharfId: '',
      kindId: '',
      payWay: '',
      boatCardSn: '',
      status: '',
      saleTime: '',
    });


    // 查询事件， 获取码头列表
    const handleQuery = async (values) => {
      const condition = utils.checkParmas(values);
      // if(!condition.saleTime)return ElMessage.error('请选择售票日期');
      if(condition.saleTime)condition.saleTime = moment(condition.saleTime).format('YYYY-MM-DD');
      pager.pageNum = 1;
      queryValue = condition;
      let url = `/sellticket/orderall?`
      Object.entries(boatKind.value).map(([prop, value]) => {
        if(value){
          url += `&${prop}=${value}`
        }
      })
      proxy.$root.$router.push(url);
      saleOrderList(condition);
    };

    const form = ref([
      {
        type: 'input',
        label: '订单号',
        model: '_id',
        placeholder: '请输入订单号'
      },
      {
        type: 'select',
        label: '码头名称',
        model: 'beginWharfId',
        placeholder: '请选择码头名称',
        options: []
      },
      {
        type: 'select',
        label: '船种名称',
        model: 'kindId',
        placeholder: '请选择船种名称',
        options: []
      },
      {
        type: 'select',
        label: '支付方式',
        model: 'payWay',
        placeholder: '请选择支付方式',
        options: []
      },
      {
        type: 'input',
        label: '船卡号',
        model: 'boatCardSn',
        placeholder: '请输入船卡号',
      },
      {
        type: 'select',
        label: '状态',
        model: 'status',
        placeholder: '请选择状态',
        options: []
      },
      {
        type: 'date',
        label: '售票日期',
        model: 'saleTime',
        placeholder: '请选择售票日期'
      },
    ]);

    // 初始化分页对象
    const pager = reactive({
      pageNum: 1,
      pageSize: 10
    });

    // 是否展示分页
    const pageShow = ref(true)
    // 定义动态表格-格式
    const columns = reactive([
      {
        type: 'index',
      },
      {
        label: '订单号',
        prop: '_id'
      },
      {
        label: '码头名称',
        prop: 'beginWharfName'
      },
      {
        label: '支付方式',
        prop: 'payWay',
        formatter (row, column, value) {
          if (value === 'crash') {
            return '现金支付'
          } else if (value === 'pos') {
            return 'POS支付'
          }
        }
      },
      {
        label: '船只名称',
        prop: "kindId.kindName",
      },
      {
        label: '船卡编号',
        prop: "boatCardId.boatCardSn",
      },
      {
        label: '状态',
        prop: 'status',
        formatter (row, column, value) {
          if (value === 'beginPlay') {
            return '开始游玩'
          } else if (value === 'endplay') {
            return '已使用'
          }else if(value === 'finish'){
            return '已完成'
          }else if(value === 'created'){
            return '已创建'
          }else if(value === 'refund'){
            return '已退票'
          }
        }
      },
      {
        label: '结算金额(元)',
        prop: 'sumPrice',
      },
      {
        label: '售票时间(分钟)',
        prop: 'saleTime',
      },
      {
        label: '结算时间(分钟)',
        prop: 'settleTime',
      },
      {
        type: 'action',
        label: '操作',
        list: [
          {
            type: 'primary',
            text: '查看',
            visible: true
          },
        ]
      }
    ]);
    // 初始化列表对象
    const kindList = ref([]);
    // 获取数据字典
    const saleOrderDict = async () => {
      const {
        wharfDict,
        kindDict,
        payTypeDict,
        StatusDict,
        } = await proxy.$api.saleOrderDict();
      // 码头字典添加
      utils.writeDict(wharfDict, form.value[1]);
      // 船种字典添加
      utils.writeDict(kindDict, form.value[2]);
      // 支付方式字典添加
      utils.writeDict(payTypeDict, form.value[3]);
      // 状态字典添加
      utils.writeDict(StatusDict, form.value[5]);
    };
    // 获取数据列表
    const saleOrderList = async (values) => {
      const params = utils.pageService(pager, values);
      const { data, totalNum } = await proxy.$api.saleOrderList(params);
      kindList.value = data;
      pager.total = totalNum;
    };
    // 分页事件处理
    const handleCurrentChange = current => {
      pager.pageNum = current;
      saleOrderList(queryValue);
    };

    const { guideTable } = useGuideTable;
    // 导出
    const exportExcel = () => {
      guideTable('/sale/order/list/export', queryValue);
    };

    // 查询单个详情
    const handleAction = values => {
      const { _id } = values.row;
      proxy.$root.$router.push(`/boat/order/orderdetails?_id=${_id}`);
    };
    const query = ref({});
    Object.entries(proxy.$root.$route.query).map(([prop, value]) => {
      if(value){
        query.value[prop] = value
        boatKind.value[prop] = value
      }
    });
    saleOrderDict();
    saleOrderList(query.value);
    return {
      saleOrderDict,
      saleOrderList,
      columns,
      pager,
      pageShow,
      kindList,
      handleCurrentChange,
      form,
      handleAction,
      boatKind,
      handleQuery,
      exportExcel,
    };
  },
};
</script>

<style scoped lang='less'>
:deep(.el-form-item){
  &:first-child{
    padding-left: 0;
  }
  &:last-child{
    padding-right: 0;
  }
  padding: 20px;
  margin-bottom: 0;
}
:deep(.el-table__body){
  .el-table_1_column_11{
    .cell{
      color: #0079FE;
      font-weight: bold;
    }
  }
}
</style>
